import { Field } from "formik";
import { RadioButton } from "components/Form/SpecialButtons";
import React from "react";

const styles = {
	groupGender: {
		width: "100%",
		display: "flex",
		flexWrap: "wrap",
		height: 50,
	},
	labelGroupGender: {
		width: "100%",
		fontSize: "0.8em",
		marginTop: 5,
		marginLeft: 2,
	},
	radioGroupGender: {
		width: "50%",
		display: "flex",
		maxWidth: "50%",
		flex: 1,
		flexBasis: "50%",
	},
	radioGroupGenderTrio: {
		width: "33%",
		display: "flex",
		maxWidth: "33%",
		flex: 1,
		flexBasis: "33%",
	},
	crossRequired: {
		color: "#c5190e",
		fontSize: "1em",
		position: "relative",
		bottom: 1,
		left: 3,
	},
};

const errorStyle = {
	color: "#dc0000",
	fontSize: "0.7em",
};

const RadioButtons = ({ customlabel, name, field1, field2, field3, errors, touched, disabled, fieldStyle, ...props }) => (
	<div>
		<div style={styles.groupGender}>
			<div style={styles.labelGroupGender}>
				{customlabel}
				{props.required && <span style={styles.crossRequired}>*</span>}
			</div>
			<div style={fieldStyle ? fieldStyle : field3 ? styles.radioGroupGenderTrio : styles.radioGroupGender}>
				<Field customlabel={field1.customlabel} component={RadioButton} name={name} id={field1.id} label="choose1" disabled={disabled} />
			</div>
			<div style={fieldStyle ? fieldStyle : field3 ? styles.radioGroupGenderTrio : styles.radioGroupGender}>
				<Field customlabel={field2.customlabel} component={RadioButton} name={name} id={field2.id} label="choose2" disabled={disabled} />
			</div>
			{field3 && (
				<div style={styles.radioGroupGenderTrio}>
					<Field customlabel={field3.customlabel} component={RadioButton} name={name} id={field3.id} label="choose3" disabled={disabled} />
				</div>
			)}
		</div>
		{touched && touched[name] && errors && errors[name] && <div style={errorStyle}>{errors[name]}</div>}
	</div>
);

export default RadioButtons;
